import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotTruck = ({
    spotColor = "#C6F4EC",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Spot=on,_Size=40_svg__a)">
            <path
                fill={spotColor}
                d="M7.104 12.673c.825-3.551 1.785-8.057 4.309-9.776 2.553-1.746 6.698-.734 9.753 1.243 3.055 1.948 5.021 4.83 7.433 7.143 2.411 2.312 5.298 4.024 7.353 6.822 2.026 2.768 3.249 6.593 3.02 10.65-.227 4.056-1.907 8.345-5.22 9.118-3.314.745-8.234-1.995-11.972-3.086-3.768-1.092-6.296-.534-10.122-.206-3.825.328-8.92.428-10.262-1.804-1.343-2.204 1.035-6.739 2.613-10.304 1.55-3.594 2.24-6.22 3.095-9.8Z"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M26.668 26.667V5h-25v21.667h25Zm0 0h11.667v-8.334l-5-5h-6.667v13.334Zm-13.334 4.167a4.167 4.167 0 1 1-8.333 0 4.167 4.167 0 0 1 8.333 0Zm21.667 0a4.167 4.167 0 1 1-8.333 0 4.167 4.167 0 0 1 8.333 0Z"
            />
        </g>
        <defs>
            <clipPath id="Spot=on,_Size=40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotTruck.displayName = "SpotTruck";
